export default __webpack_public_path__ + "static/media/images.49095b52.jpg";